import anime, { set } from 'animejs';
import React, { useState, useEffect } from 'react';
import FramePlayer from '../utils/FramePlayer';
import ImageButton from '../utils/ImageButton';
import { Navigate, useNavigate } from 'react-router-dom';
import lang from '../lang.json';

const StartScreenWithoutIntro = (props) => {

    const firstTime = props.firstTime;
    const setFirstTime = props.setFirstTime;

    const [red1, setRed1] = useState(false);
    const [red2, setRed2] = useState(false);

    const [showLangue, setShowLangue] = useState(false);

    const [showCredits, setShowCredits] = useState(false);

    const [showToots, setShowToots] = useState(false);

    const navigate = useNavigate();

    const langue = props.langue;
    const setLangue = props.setLangue;
    const texts = lang.lang[`lang_${langue}`].accueil

    useEffect(() => {
        var tl = anime.timeline({
            //complete: callback
        })
        tl
            .add({
                targets: '.black-trans-1',
                opacity: 0,
                duration: 0,
            })
            .add({
                targets: '.colorBg',
                opacity: 0,
                duration: 0,
            }, 0)
            .add({
                targets: '.framePlayer',
                opacity: 1,
                duration: 0,
            }, 0)
            .add({
                targets: '.greyBg',
                opacity: 1,
                duration: 0,
            }, 0);
    }, []);

    useEffect(() => {
    if (red1) {
        window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/menudida/';
        //navigate(process.env.PUBLIC_URL + '/menudida/');
    }
    }, [red1]);

    useEffect(() => {
        if (red2) {
            window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur/menumusic/';
            //navigate(process.env.PUBLIC_URL + '/menumusic/');
        }
    }, [red2]);


    return (
        <>
            <img className='colorBg'
                src={process.env.PUBLIC_URL + "/assets/images/start_screen/background.jpg"}
                alt="background image"
                style={{ position: "absolute", left: 0, top: 0 }} />
            <img className='greyBg'
                src={process.env.PUBLIC_URL + "/assets/images/start_screen/grey_background.png"}
                alt="background image"
                style={{ position: "absolute", left: 0, top: 0, opacity: 0 }} />
            {firstTime ?
                <FramePlayer
                    className='framePlayer'
                    dirName="start_title"
                    frameNumber={16}
                    fps={8}
                    initialDelay={2200}
                    onEnd={() => { setFirstTime(false) }}
                    style={{ zIndex: '1', opacity: 0 }} />
                : <img className='letters'
                    src={process.env.PUBLIC_URL + "/assets/images/start_screen/letters.png"}
                    style={{ position: "absolute", left: 0, top: 0 }} />
            }

            {/*menu dida*/}
            <div
                style={{
                    scale: 1,
                }}
                //when hovered sclae to 1.1
                onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.1)";
                }}
                //when unhovered scale back to 1
                onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                }}
            >
                <ImageButton
                    dirName="start_screen"
                    id="1"
                    x={249}
                    y={13}
                    callback={() => {
                        setRed1(true);
                    }}
                    style={{
                        zIndex: 2,
                        cursor: "pointer",
                    }} />
                <p
                    style={{
                        position: "absolute",
                        left: 370,
                        top: 40,
                        zIndex: 3,
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        setRed1(true);
                    }}
                >
                    {texts.lang5}
                </p>
            </div>

            <div
                style={{
                    scale: 1,
                }}
                //when hovered sclae to 1.1
                onMouseEnter={(e) => {
                    e.target.style.transform = "scale(1.1)";
                }}
                //when unhovered scale back to 1
                onMouseLeave={(e) => {
                    e.target.style.transform = "scale(1)";
                }}
            >
                <ImageButton
                    dirName="start_screen"
                    id="2"
                    x={199}
                    y={118}
                    callback={() => {
                        setRed2(true);
                    }}
                    style={{
                        zIndex: 2,
                        cursor: "pointer",
                    }} />

                <p
                    style={{
                        position: "absolute",
                        left: 210,
                        top: 200,
                        zIndex: 3,
                        cursor: "pointer",
                    }}
                    onClick={() => {
                        setRed2(true);
                    }}
                >
                    {texts.lang6}
                </p>
            </div>

            <div className='black-trans-1' />
            { red1 && <Navigate to={process.env.PUBLIC_URL + "/menudida/"} /> }
            {red2 && <Navigate to={process.env.PUBLIC_URL + "/menumusic/"} />}

            {/* barre bas d'écran */}
            <div
                style={{
                    position: "absolute",
                    left: 0,
                    top: 450,
                    width: "660px",
                    height: "50px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                }}
            >
                {/* bouton crédits */}
                <div
                    style={{
                        position: "absolute",
                        left: 450,
                        top: 10,
                        width: "100px",
                        backgroundColor: "black",
                        color: "white",
                        textAlign: "center",
                        fontSize: "14px",
                        padding: "5px",
                        cursor: "pointer",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onMouseLeave={() => { setShowCredits(false); }}
                >
                    {texts.lang3}
                </div>
                <img
                    style={{
                        position: "absolute",
                        left: 270,
                        top: -360,
                        zIndex: 5,
                        display: showCredits ? "block" : "none",
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/start_screen/credits.png"}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onMouseLeave={() => { setShowCredits(false); }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: 270,
                        top: -279,
                        zIndex: 5,
                        width: "300px",
                        height: "15px",
                        cursor: "pointer",
                        display: showCredits ? "block" : "none",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onClick={() => {
                        //redirect to extern page
                        window.open("http://omax.ircam.fr", "_blank");
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: 270,
                        top: -265,
                        zIndex: 5,
                        width: "300px",
                        height: "15px",
                        cursor: "pointer",
                        display: showCredits ? "block" : "none",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onClick={() => {
                        //redirect to extern page
                        window.open("http://recherche.ircam.fr/equipes/repmus/lubat", "_blank");
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: 270,
                        top: -178,
                        zIndex: 5,
                        width: "300px",
                        height: "15px",
                        cursor: "pointer",
                        display: showCredits ? "block" : "none",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onClick={() => {
                        //redirect to extern page
                        window.open("http://www.uzeste.org", "_blank");
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: 410,
                        top: -128,
                        zIndex: 5,
                        width: "200px",
                        height: "15px",
                        cursor: "pointer",
                        display: showCredits ? "block" : "none",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onClick={() => {
                        //redirect to extern page
                        window.open("http://ikotame.com", "_blank");
                    }}
                />
                <div
                    style={{
                        position: "absolute",
                        left: 270,
                        top: -30,
                        zIndex: 5,
                        width: "300px",
                        height: "15px",
                        cursor: "pointer",
                        display: showCredits ? "block" : "none",
                    }}
                    onMouseEnter={() => { setShowCredits(true); }}
                    onClick={() => {
                        //redirect to extern page
                        window.open("http://ehess.modelisationsavoirs.fr/lubat/mediation/data/accueil/credits.html", "_blank");
                    }}
                />
                {/* bouton toots */}
                <div
                    style={{
                        position: "absolute",
                        left: 250,
                        top: 10,
                        width: "200px",
                        backgroundColor: "black",
                        color: "white",
                        textAlign: "center",
                        fontSize: "14px",
                        padding: "5px",
                        cursor: "pointer",
                    }}
                    onMouseEnter={() => { setShowToots(true); }}
                    onMouseLeave={() => { setShowToots(false); }}
                    onClick={() => { 
                        window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/';
                        //navigate(process.env.PUBLIC_URL + '/toots/'); 
                        }}
                >
                    TOOTS THIELEMANS
                </div>
                <img
                    style={{
                        position: "absolute",
                        left: 250,
                        top: -185,
                        width: "200px",
                        zIndex: 5,
                        display: showToots ? "block" : "none",
                        cursor: "pointer",
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/start_screen/logo-toots.png"}
                    onMouseEnter={() => { setShowToots(true); }}
                    onMouseLeave={() => { setShowToots(false); }}
                    onClick={() => { window.parent.location.href = 'https://digitaljazz.fr/improvisationordinateur' + '/toots/';
                        //navigate(process.env.PUBLIC_URL + '/toots/'); 
                        }}
                />

                {/* logo ircam */}
                <img
                    style={{
                        position: "absolute",
                        left: 10,
                        top: 10,
                        height: "30px",
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/start_screen/ircam.png"}
                />
                <img
                    style={{
                        position: "absolute",
                        left: 70,
                        top: 13,
                        height: "20px",
                    }}
                    src={process.env.PUBLIC_URL + "/assets/images/start_screen/comp.png"}
                />
                <p
                    style={{
                        position: "absolute",
                        left: 10,
                        top: -42,
                        color: "yellow",
                        fontSize: "15px", //PB1 augmentation de la taille 
                        width: "600px",
                    }}
                >
                    {texts.lang2}
                </p>

                {/* drop down menu pour langues */}
                <div
                    onMouseEnter={() => { setShowLangue(true); }}
                    onMouseLeave={() => { setShowLangue(false); }}
                >
                    <div
                        style={{
                            position: "absolute",
                            left: 550,
                            top: 10,
                            width: "100px",
                            backgroundColor: "black",
                            color: "white",
                            textAlign: "center",
                            fontSize: "14px",
                            padding: "5px",
                            cursor: "pointer",
                        }}
                    >
                        {texts.lang4}
                    </div>
                    {/* choix langues */}
                    <div
                        style={{
                            position: "absolute",
                            left: 540,
                            top: -130,
                            width: "100px",
                            backgroundColor: langue === 'fr' ? "#ceaf00" : "#e6d2ab",
                            color: "black",
                            textAlign: "center",
                            fontSize: "16px",
                            padding: "5px",
                            zIndex: 12,
                            display: showLangue ? "block" : "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setLangue('fr');
                        }}
                    >
                        français
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            left: 540,
                            top: -102,
                            width: "100px",
                            backgroundColor: langue === 'en' ? "#ceaf00" : "#e6d2ab",
                            color: "black",
                            textAlign: "center",
                            fontSize: "16px",
                            padding: "5px",
                            zIndex: 6,
                            display: showLangue ? "block" : "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setLangue('en');
                        }}
                    >
                        english
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            left: 540,
                            top: -74,
                            width: "100px",
                            backgroundColor: langue === 'es' ? "#ceaf00" : "#e6d2ab",
                            color: "black",
                            textAlign: "center",
                            fontSize: "16px",
                            padding: "5px",
                            zIndex: 6,
                            display: showLangue ? "block" : "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setLangue('es');
                        }}
                    >
                        espanol
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            left: 540,
                            top: -46,
                            width: "100px",
                            backgroundColor: langue === 'de' ? "#ceaf00" : "#e6d2ab",
                            color: "black",
                            textAlign: "center",
                            fontSize: "16px",
                            padding: "5px",
                            zIndex: 6,
                            display: showLangue ? "block" : "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setLangue('de');
                        }}
                    >
                        deutsch
                    </div>
                    <div
                        style={{
                            position: "absolute",
                            left: 540,
                            top: -18,
                            width: "100px",
                            backgroundColor: langue === 'oc' ? "#ceaf00" : "#e6d2ab",
                            color: "black",
                            textAlign: "center",
                            fontSize: "16px",
                            padding: "5px",
                            zIndex: 6,
                            display: showLangue ? "block" : "none",
                            cursor: "pointer",
                        }}
                        onClick={() => {
                            setLangue('oc');
                        }}
                    >
                        occitan
                    </div>
                </div>
            </div>

        </>
    );
}

export default StartScreenWithoutIntro;
